var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"go-back"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-back",on:{"click":_vm.goBack}},[_vm._v("Ga terug")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }